window.loadIMG = {
  configNum:2,
  institution: "花生助教",
  systemName: "花生助教教务机构管理系统",
  bgTitle: "让您管理校区更轻松",
  link: "hs.huasheng5.com",
  corporateName: "河南胡桃网络科技有限公司",
  corporateUser: "李老师",
  corporatePhone: "18860397870",
  corporateAddress: "河南省郑州市高新技术产业开发区莲花街198号5号楼2单元1501号",
  salesPhone: "18860397870", //售后电话
  emptyImage: "", //无数据 提示图 不写就不显示
  homePagebg:
    "https://pxboss.xiaohebang.cn/system/front/oem/huasheng/phone/homebg.png", //homepage页背景
  myPagebg:
    "https://pxboss.xiaohebang.cn/system/front/oem/huasheng/phone/selfbg.png", //selfpage页背景
  noticIcon:
    "https://pxboss.xiaohebang.cn/system/material/teacher/new/other/notic.png", //homepage 滚动通知栏的小喇叭
  indexIcon:
    "https://pxboss.xiaohebang.cn/system/front/oem/huasheng/phone/indexIcon.png", //首页 没选中
  indexIconA:
    "https://pxboss.xiaohebang.cn/system/front/oem/huasheng/phone/indexIconA.png", //首页选中
  myIcon:
    "https://pxboss.xiaohebang.cn/system/front/oem/huasheng/phone/myIcon.png", // 我的 没选中
  myIconA:
    "https://pxboss.xiaohebang.cn/system/front/oem/huasheng/phone/myIconA.png", //我的 选中

  bgimg: "https://pxboss.xiaohebang.cn/system/front/oem/huasheng/phone/selfbg.png", //我的页面  学员详情 的背景
  bgimg1: "https://pxboss.xiaohebang.cn/system/default/om/ddzj/hsbg.png", //充值页面  的背景

  backgroundImage:
    "https://pxboss.xiaohebang.cn/system/front/oem/huasheng/phone/loginbg.png", //登录页背景

  aboutmeImg: "https://pxboss.xiaohebang.cn/system/front/oem/huasheng/pc/favicon.png", //关于我们 logo

  qrCode:
    "https://pxboss.xiaohebang.cn/system/front/oem/huasheng/phone/qrCode.png", //我的页面 二维码
  bluePen:
    "https://pxboss.xiaohebang.cn/system/front/oem/huasheng/phone/bluePen.png", //我的页面编辑按钮
  tjyj: "https://pxboss.xiaohebang.cn/system/front/oem/huasheng/phone/tjyj.png", //我的 推荐有奖
  yjfk: "https://pxboss.xiaohebang.cn/system/front/oem/huasheng/phone/yjfk.png", // 我的 意见反馈
  gywm: "https://pxboss.xiaohebang.cn/system/front/oem/huasheng/phone/gywm.png", // 我的 关于我们
  zxzh: "https://pxboss.xiaohebang.cn/system/front/oem/huasheng/phone/zxzh.png", // 我的 注销账号

  moreIcon:
    "https://pxboss.xiaohebang.cn/system/front/oem/huasheng/phone/more.png", //首页 更多

  boy: "https://pxboss.xiaohebang.cn/system/default/om/ddzj/img/boy.png", //男生
  girl: "https://pxboss.xiaohebang.cn/system/default/om/ddzj/img/girl.png", //女生
  youArrow: "https://pxboss.xiaohebang.cn/system/front/oem/huasheng/phone/right.png",
  registerbg:
    "https://pxboss.xiaohebang.cn/system/front/oem/huasheng/phone/rebg.png", //注册页
  refreshBtn:
    "https://pxboss.xiaohebang.cn/system/front/oem/huasheng/phone/chongzhi.png", //重置按钮
  arrowDm:
    "https://pxboss.xiaohebang.cn/system/front/oem/huasheng/phone/arrowDm.png",
  jwsj: [
    { name: "1", label: "授课统计" },
    { name: "0", label: "数据概况" }
    // { name: "dayData2", label: "课消统计" },
  ],
  zssj: [
    { name: "2", label: "招生排名" },
    { name: "1", label: "招生趋势" },
    { name: "0", label: "数据概况" }
  ],
  xssj: [
    { name: "1", label: "销售额分析" },
    { name: "2", label: "销售额月统计" },
    { name: "0", label: "数据概况" }
  ],
  status1: "https://pxboss.xiaohebang.cn/system/front/oem/huasheng/phone/status1.png",
  status2: "https://pxboss.xiaohebang.cn/system/front/oem/huasheng/phone/status2.png",
  status3: "https://pxboss.xiaohebang.cn/system/front/oem/huasheng/phone/status3.png",
  blackPanel:
    "https://pxboss.xiaohebang.cn/system/material/teacher/new/other/blackPanel.png",

  confirmButtonColor: "#ff4210"
};



// WEBPACK FOOTER //
// ./src/style_hs/loadimage.js